import React from 'react';

// Écran de reprise affiché quand un client a déjà un entretien.
// Boutons adaptés à l'état : en_cours → Continuer ; terminé → Voir les aides.
export default function ResumePhase({ client, dernierEntretien, dernierMatching, onContinue, onVoirAides, onRecommencer }) {
  const p = client?.profil || {};
  const enCours = dernierEntretien?.statut === 'en_cours';
  const dernierTour = dernierEntretien?.turns?.[dernierEntretien.turns.length - 1];
  const profilLigne = [
    p.age && `${p.age} ans`, p.departement, p.situationLogement,
    p.girNiveau && `GIR ${p.girNiveau}`,
    p.revenuFiscalReference && `${p.revenuFiscalReference.toLocaleString('fr-FR')} €/an`,
  ].filter(Boolean).join(' · ');

  const card = { background:'#FDFCFA', border:'1px solid #E0DDD8', borderRadius:12, padding:20, maxWidth:680, margin:'0 auto' };
  const label = { fontSize:11, fontWeight:700, color:'#8A8A8A', textTransform:'uppercase', letterSpacing:0.5, marginTop:14, marginBottom:4 };
  const btn = (bg, color) => ({ padding:'10px 18px', borderRadius:9, border: bg==='transparent'?'1px solid #D9D9D9':'none', background:bg, color, fontSize:14, fontWeight:600, cursor:'pointer' });

  return (
    <div style={{ padding:'24px 16px' }}>
      <h2 style={{ textAlign:'center', color:'#5A3C1F', fontSize:20, marginBottom:18 }}>
        Reprise du dossier — {client?.nom || 'Client'}
      </h2>
      <div style={card}>
        <div style={{ fontSize:12, color:'#8A8A8A' }}>
          Statut : {client?.statut} · Dernier contact : {dernierEntretien ? new Date(dernierEntretien.updatedAt).toLocaleString('fr-FR') : '—'}
        </div>
        {profilLigne && (<><div style={label}>Profil déjà collecté</div><div style={{ fontSize:14, color:'#2D2D2D' }}>{profilLigne}</div></>)}
        {dernierMatching && (
          <><div style={label}>Dernières aides trouvées ({dernierMatching.nbAides})</div>
          <div style={{ fontSize:13, color:'#3D8B5E' }}>
            {dernierMatching.recommandations.slice(0,3).map(a => a.nom).join(' · ')}
            {dernierMatching.nbAides > 3 ? ` … (+${dernierMatching.nbAides - 3})` : ''}
          </div></>
        )}
        {dernierTour && (<><div style={label}>Dernier échange</div>
          <div style={{ fontSize:13, color:'#5A5A5A', fontStyle:'italic' }}>« {dernierTour.content} »</div></>)}
      </div>
      <div style={{ display:'flex', gap:12, justifyContent:'center', marginTop:20, flexWrap:'wrap' }}>
        {enCours && <button onClick={onContinue} style={btn('#D4724A', '#fff')}>▶ Continuer l'entretien</button>}
        {dernierMatching && <button onClick={onVoirAides} style={btn('#3D8B5E', '#fff')}>Voir les {dernierMatching.nbAides} aides</button>}
        <button onClick={onRecommencer} style={btn('transparent', '#8A8A8A')}>↺ Recommencer</button>
      </div>
    </div>
  );
}
